/**
 * RenderingProgressOverlay Component
 * EXACT PORT dari ModelViewerBACKUP.jsx line 16701-16870
 * 
 * Large modal overlay untuk high-quality rendering:
 * - Phase-specific title & description
 * - Progress bar dengan animation
 * - Percentage display
 * - Frame count info
 * - Cancel button
 */

import React from 'react'

export default function RenderingProgressOverlay({
  isRendering,
  renderingPhase,
  renderProgress,
  videoFrameRate,
  videoDuration,
  onCancel,
}) {
  if (!isRendering) return null

  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 9999,
        background:
          'linear-gradient(135deg, rgba(20, 20, 30, 0.95) 0%, rgba(10, 10, 15, 0.98) 100%)',
        backdropFilter: 'blur(30px) saturate(190%)',
        WebkitBackdropFilter: 'blur(30px) saturate(190%)',
        borderRadius: '20px',
        padding: '32px 40px',
        boxShadow:
          '0 8px 32px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.1)',
        border: '0.5px solid rgba(255, 255, 255, 0.15)',
        minWidth: '320px',
        textAlign: 'center',
      }}
    >
      {/* Icon */}
      <div
        style={{
          fontSize: '48px',
          marginBottom: '16px',
          animation: 'pulseGlow 2s ease-in-out infinite',
        }}
      >
        🎬
      </div>

      {/* Title */}
      <div
        style={{
          color: '#fff',
          fontSize: '18px',
          fontWeight: 600,
          marginBottom: '8px',
          fontFamily: 'system-ui, -apple-system, sans-serif',
        }}
      >
        {renderingPhase === 'capturing' && '🎬 Capturing Frames'}
        {renderingPhase === 'encoding' && '🎞️ Encoding Video'}
        {renderingPhase === 'complete' && '✅ Complete!'}
      </div>

      {/* Description */}
      <div
        style={{
          color: 'rgba(255, 255, 255, 0.6)',
          fontSize: '12px',
          marginBottom: '8px',
          fontFamily: 'system-ui, -apple-system, sans-serif',
        }}
      >
        {renderingPhase === 'capturing' &&
          `Capturing ${videoFrameRate * videoDuration} frames at ${videoFrameRate} FPS`}
        {renderingPhase === 'encoding' && 'Encoding video with MediaRecorder'}
        {renderingPhase === 'complete' && 'Finalizing and downloading...'}
      </div>

      {/* Extra Info */}
      <div
        style={{
          color:
            renderingPhase === 'capturing'
              ? 'rgba(139, 92, 246, 0.9)'
              : 'rgba(16, 185, 129, 0.9)',
          fontSize: '11px',
          marginBottom: '20px',
          fontFamily: 'system-ui, -apple-system, sans-serif',
        }}
      >
        {renderingPhase === 'capturing' &&
          `✨ Animation stretched to ${videoDuration}s`}
        {renderingPhase === 'encoding' &&
          `🎞️ Encoding ${videoFrameRate} FPS video...`}
        {renderingPhase === 'complete' && '✅ Download starting...'}
      </div>

      {/* Progress Bar */}
      <div
        style={{
          width: '100%',
          height: '8px',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '4px',
          overflow: 'hidden',
          marginBottom: '12px',
        }}
      >
        <div
          style={{
            width: `${renderProgress}%`,
            height: '100%',
            background: 'linear-gradient(90deg, #8b5cf6, #6366f1)',
            borderRadius: '4px',
            transition: 'width 0.3s ease-out',
            boxShadow: '0 0 10px rgba(139, 92, 246, 0.5)',
          }}
        />
      </div>

      {/* Progress Text */}
      <div
        style={{
          color: '#fff',
          fontSize: '20px',
          fontWeight: 600,
          marginBottom: '8px',
          fontFamily: 'monospace',
        }}
      >
        {renderProgress}%
      </div>

      {/* Frame Info */}
      <div
        style={{
          color: 'rgba(255, 255, 255, 0.5)',
          fontSize: '11px',
          marginBottom: '16px',
          fontFamily: 'system-ui, -apple-system, sans-serif',
        }}
      >
        Rendering frames... Please wait
      </div>

      {/* Cancel Button */}
      <button
        onClick={onCancel}
        style={{
          padding: '10px 24px',
          backgroundColor: 'rgba(239, 68, 68, 0.9)',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: 600,
          fontFamily: 'system-ui, -apple-system, sans-serif',
          transition: 'all 0.2s',
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#dc2626'
          e.target.style.transform = 'scale(1.05)'
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'rgba(239, 68, 68, 0.9)'
          e.target.style.transform = 'scale(1)'
        }}
      >
        Cancel
      </button>
    </div>
  )
}

